export const LOCAL_TIME_UNITS = [
    { plural: 'days', singular: 'day', divider: 86400000 },
    { plural: 'hours', singular: 'hour', divider: 3600000, digits: 2 },
    { plural: 'minutes', singular: 'minute', divider: 60000, digits: 2 },
    { plural: 'seconds', singular: 'second', divider: 1000, digits: 2 }
];
